import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminProjectsInProgress = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS.GET_ALL, { params });
    return response.data;
};

export const getAdminProjectInProgressById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS.GET_BY_ID(id));
    return response.data;
};

export const createProjectInProgress = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS.CREATE, data);
    return response.data;
};

export const updateProjectInProgress = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS.UPDATE(id), data);
    return response.data;
};

export const deleteProjectInProgress = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.PROJECTS_IN_PROGRESS.DELETE(id));
    return response.data;
};
